var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('static-header'),_c('destacate',{attrs:{"course":_vm.cours}}),_c('get-course')],1)}
var staticRenderFns = []

export { render, staticRenderFns }